import { createLogic } from 'redux-logic';
import omit from 'lodash/omit';
import { routeToProperty } from 'store/search/searchActions';
import { getPropertyLinkQuery } from 'store/search/searchSelectors/getPropertyLinkQuery';
import createSearchQueryString from 'lib/search/createSearchQueryString';
import setUrl from 'lib/routing/setUrl';

export const routeToPropertyLogic = createLogic({
  type: routeToProperty,
  async process({ action, getState }, dispatch, done) {
    const { id, excludeParams } = action.payload;
    const propertyLinkQuery = getPropertyLinkQuery(getState());
    const sanitizedQuery = omit(propertyLinkQuery, excludeParams);
    const propertyLinkQueryString = createSearchQueryString(sanitizedQuery);
    setUrl(`/hotels/properties/${id}?${propertyLinkQueryString}`);
    done();
  },
});
